export default __webpack_public_path__ + "static/nosChambres-0d25eb0528092937b5b6fb8b917fcecd.png";